
import { useMemo } from "react";
import { useRecoilValue } from "recoil" ;
import { translationsState } from "state/ecoState";

/**
 * Get translations 
 */
const useTranslations = (key: string | Array<string>, ...params: string[] ) => {
    const map = useRecoilValue(translationsState) ;
  
    return useMemo(() => {
        return map.get(key, ...params);
    }, [key, params])
} ;

export default useTranslations ;